import config from '@/config';
import { mapActions, mapState } from 'vuex';


export default {
  data() {
    return {
      loginWindowRef: null,
    };
  },
  computed: {
    ...mapState('app', [
      'accessToken',
    ]),
  },
  methods: {
    ...mapActions('app', [
      'setAccessToken',
    ]),
    goToLogin() {
      this.$log.info('go to login');
      if (this.loginWindowRef) {
        this.$log.info('has login window ref');
        return;
      }
      this.isLoading = true;
      this.$log.debug('processing login with device:', this.device);
      if (this.device) {
        this.$log.debug('app runs on device. Opening login window', config.ICOOL.LOGIN_URL);
        const loginWindowRef = cordova.InAppBrowser.open(
          config.ICOOL.LOGIN_URL, '_blank', 'location=no,hidden=yes,zoom=no,toolbar=no',
        );
        this.loginWindowRef = loginWindowRef;
        this.loginWindowRef.addEventListener('loaderror', this.loginWindowLoadError);
        this.loginWindowRef.addEventListener('message', this.loginWindowMessage);
        this.loginWindowRef.addEventListener('loadstop', this.loginWindowLoadStop);
      } else {
        window.location = config.ICOOL.LOGIN_URL;
      }
    },
    fetchAccessToken() {
      this.$log.debug('fetching access token');
      const accessToken = this.$cookies.get('access_token');
      if (!accessToken) {
        this.$log.debug('access token not available. Go to login');
        this.goToLogin();
      }
      this.$cookies.remove('access_token');
      this.processAccessToken(accessToken);
    },
    loginWindowLoadError(payload) {
      this.$log.error('login window load error', payload);
      this.destroyLoginWindow();
    },
    loginWindowLoadStop(payload) {
      this.$log.debug('login window loaded.', payload.url);
      this.loginWindowRef.show();
      if (payload.url.endsWith('oauth2/login/successful')) {
        this.loginWindowRef.hide();
        this.$log.debug('Running fetching access token script in loginWindow');
        this.loginWindowRef.executeScript(
          {
            code: `
              if(!webkit.messageHandlers.cordova_iab) throw "Cordova IAB postMessage API not found";
              function getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                  var c = ca[i];
                  while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                  }
                  if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                  }
                }
                return "";
              }
              var messageObj = {access_token: getCookie('access_token')};
              var stringifiedMessageObj = JSON.stringify(messageObj);
              webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
            `,
          },
          this.loginWindowScriptExecustionCallback,
        );
      }
    },
    loginWindowScriptExecustionCallback(payload) {
      this.$log.debug('login window script executed', payload);
    },
    loginWindowMessage(payload) {
      const { data } = payload;
      if (data.access_token) {
        this.processAccessToken(data.access_token);
      }
      this.destroyLoginWindow();
    },
    processAccessToken(accessToken) {
      this.setAccessToken(accessToken);
      this.configureAccessToken(accessToken);
    },
    destroyLoginWindow() {
      this.loginWindowRef.close();
      this.loginWindowRef = undefined;
    },
  },
};
